const PERSISTENT_SCA_ACCESS_KEY = 'persistent_sca_access';

const SCAActionsConstants = Object.freeze({
  OVERVIEW_CHARTS_AND_TABLES_LOADING_ACTION: 'overview_charts_and_tables_loading',
  BALANCE_LOADING: PERSISTENT_SCA_ACCESS_KEY,
  ADD_FUNDS_LOADING: PERSISTENT_SCA_ACCESS_KEY,
  // subscription action
  SUBSCRIPTION_CARD_CREATION_ACTION: 'subscription_card_creation',
  SUBSCRIPTION_CARD_RECREATE_ACTION: 'subscription_card_recreate',
  SUBSCRIPTION_CREATION_WITH_CARD_ACTION: 'subscription_creation_with_card',
  SUBSCRIPTION_BUDGET_EDITION_ACTION: 'subscription_budget_edition_action',
  SUBSCRIPTION_BULK_CREATION_WITH_CARD_ACTION: 'subscription_bulk_creation_with_card',
  SUBSCRIPTION_CHANGE_CARD_ACTION: 'subscription_change_card',
  SUBSCRIPTION_CHANGE_PAYMENT_METHOD_ACTION: 'subscription_change_payment_method',
  SUBSCRIPTION_CHANGE_STATUS_ACTION: 'subscription_change_status',
  SUBSCRIPTION_DELETE: 'subscription_delete',
  SUBSCRIPTION_EDIT_ACTION: 'subscription_edit_action',
  SUBSCRIPTION_SUBMIT: 'subscription_submit',
  SUBSCRIPTION_SUBMIT_IN_CREATION: 'subscription_submit_in_creation',
  // transaction actions
  TRANSACTIONS_OLDER_90_DAYS_LOADING_ACTION: 'long_sca_session',
  TRANSACTIONS_WITHIN_90_DAYS_LOADING_ACTION: 'long_sca_session',
  TRANSACTIONS_DOWNLOAD_PDF_AND_CSV_ACTION: PERSISTENT_SCA_ACCESS_KEY,
  // card actions
  CARD_ACTIVATE_ACTION: 'card_activate_action',
  CARD_CREATION_ACTION: 'card_creation',
  CARD_DELETE_ACTION: PERSISTENT_SCA_ACCESS_KEY,
  CARD_EDITION_ACTION: 'card_edition',
  CARD_PAUSE_ACTION: 'card_pause_action',
  CARD_SET_NEW_PIN_ACTION: 'card_set_new_pin_action',
  CARD_UNBLOCK_PIN_ACTION: 'card_unblock_pin_action',
  LOCK_CARD_ACTION: 'lock_card',
  UNLOCK_CARD_ACTION: 'unlock_card',
  DISPLAY_CARD_DETAILS_ACTION: 'display_card_details',
  // user actions
  DISABLE_USER_WITH_TREEZOR_ACCOUNT_ACTION: 'disable_user_with_treezor_account',
  ENABLE_USER_WITH_TREEZOR_ACCOUNT_ACTION: 'enable_user_with_treezor_account',
  // vendor actions
  VENDOR_CREATION_ACTION: 'vendor_creation',
  VENDOR_DELETE_ACTION: 'vendor_delete',
  VENDOR_UPDATE_STATUS_ACTION: 'vendor_update_status',
  // payment action
  PAYMENT_CREATE_ACTION: 'payment_create_action',
  BENEFICIARY_VALIDATE_ACTION: 'long_sca_session'
});

const SCASessionTypesConstants = Object.freeze({
  LONG_SESSION: 'long_session', // long session means 90 days
  FIVE_MINUTES_SESSION: 'session', // session means every 5 minutes
  PER_OPERATION_SESSION: 'operation' // operation means every time
});

const SCAEnrollmentMethodConstants = Object.freeze({
  WITHLESS_MOBILE: 'withless_mobile',
  KEYLESS: 'keyless',
  SMS: 'sms'
});

export {
  SCAActionsConstants,
  SCASessionTypesConstants,
  SCAEnrollmentMethodConstants,
  PERSISTENT_SCA_ACCESS_KEY
};
